module.exports = __webpack_public_path__ + "blackmantis.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackmantis.png
// module id = 860
// module chunks = 0